import React from "react";

import ProductPage from "../routes/product";

const ProductTemplate = (props) => <ProductPage {...props} />;

export default ProductTemplate;
